import React from 'react';
import { Button, FormControl, InputLabel, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, SelectChangeEvent, List, ListItem, ListItemText, IconButton } from '@mui/material/';
import UnfiledReport from '../dataObjects/UnfliledReport';
import LocalFilerRecord from '../dataObjects/LocalFilerRecord';
import LitigationDeadline from '../dataObjects/LitigationDeadline';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
interface Props {
    currentUnfiledReport: UnfiledReport | null;
    currentRecord: LocalFilerRecord | LitigationDeadline | null;

    openUnfiledReportDialog: boolean;
    isEditing: boolean;
    openDialog: boolean;

    isLitigationTab: boolean;

    handleCloseDialog: () => void;

    handleOpenUnfiledReportDialog: () => void;
    handleCloseUnfiledReportDialog: () => void;
    handleUnfiledReportInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleDeleteUnfiledReport: (unfiledReportId: number) => Promise<void>;
    handleSaveUnfiledReport: () => Promise<void>;

}

const EditOrAddNewUnfiledReport = (props: Props) => {
    const reportTypeOptions = [
        { id: 10, name: 'Initial Report (D102)' },
        { id: 11, name: 'Year-End Report (D102)' },
        { id: 12, name: 'Dissolution Report (D102)' },
        { id: 13, name: 'Other Report (D102)' },
        { id: 14, name: 'Transition-Out Report' },
        { id: 15, name: 'Transition-In Report' },
        { id: 16, name: 'Year-End Report (D102-L)' },
        { id: 20, name: 'Pre-primary Report (ND)' },
        { id: 21, name: 'Pre-election Report (ND)' },
        { id: 22, name: 'Pre-primary Report (Special) (ND)' },
        { id: 23, name: 'Pre-election Report (Special) (ND)' },
        { id: 24, name: 'Year-end Report (ND)' },
        { id: 25, name: 'Dissolution Report (ND)' },
        { id: 26, name: 'Post-election Report (ND)' },
        { id: 27, name: 'Other Report (ND)' },
        { id: 28, name: 'Mid-Year Report (ND)' },
        { id: 29, name: 'Transition Report' },
        { id: 60, name: 'Deposit Report' },
        { id: 63, name: 'Subvendor Report' },
        { id: 65, name: 'Payroll Itemization Report' },
        { id: 66, name: 'Bank Expenditure Itemization Report' },
        { id: 80, name: 'Credit Card Report' },
        { id: 90, name: 'Reimbursement Report' }
    ];

    const reportStatusOptions = [
        { id: 0, name: 'Outstanding' },
        { id: 1, name: 'Filed After Referral' },
        { id: 2, name: 'Filed After Complaint' },
    ];


    const handleSelectChange = (event: SelectChangeEvent<number>) => {
        const selectedReportType = reportTypeOptions.find(option => option.id === event.target.value);

        if (selectedReportType) {
            // Create a synthetic event for the id
            const syntheticEventId = {
                target: {
                    name: 'reportTypeId',
                    value: selectedReportType.id.toString(),
                },
            } as React.ChangeEvent<HTMLInputElement>;

            // Create a synthetic event for the name
            const syntheticEventName = {
                target: {
                    name: 'reportTypeDescription',
                    value: selectedReportType.name,
                },
            } as React.ChangeEvent<HTMLInputElement>;

            // Pass both events to handleUnfiledReportInputChange
            props.handleUnfiledReportInputChange(syntheticEventId);
            props.handleUnfiledReportInputChange(syntheticEventName);
        }
    };

    return (
        <div>

            <Dialog open={props.openDialog} onClose={props.handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>{props.isEditing ? 'Edit Filer Record' : 'Add New Filer Record'}</DialogTitle>
                <DialogContent>
                    <h4>Unfiled Reports</h4>
                    <List>
                        {props.currentRecord?.unfiledReports.map((report) => (
                            <ListItem key={report.unfiledReportId}>
                                <ListItemText
                                    primary={`${report.reportTypeDescription} (${report.year}) ${report.reportStatusDescription}`}
                                />
                                <IconButton edge="end" aria-label="delete" onClick={() => props.handleDeleteUnfiledReport(report.unfiledReportId)}>
                                    <DeleteIcon />
                                </IconButton>
                            </ListItem>
                        ))}
                    </List>
                    <Button
                        startIcon={<AddIcon />}
                        onClick={() => props.handleOpenUnfiledReportDialog()}
                    >
                        Add Unfiled Report
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleCloseDialog}>Close</Button>
                </DialogActions>
            </Dialog>


            <Dialog open={props.openUnfiledReportDialog} onClose={props.handleCloseUnfiledReportDialog}>
                <DialogTitle>{props.currentUnfiledReport?.unfiledReportId ? 'Edit Unfiled Report' : 'Add Unfiled Report'}</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="dense">
                        <InputLabel id="report-type-label">Report Type</InputLabel>
                        <Select
                            labelId="report-type-label"
                            id="report-type-select"
                            name="reportTypeId"
                            value={props.currentUnfiledReport?.reportTypeId || ''}
                            onChange={handleSelectChange}
                            fullWidth
                            label="Report Type"
                            variant="outlined"
                        >
                            <MenuItem value="" disabled>
                                Select a report type
                            </MenuItem>
                            {reportTypeOptions.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        name="year"
                        label="Year"
                        type="number"
                        value={props.currentUnfiledReport?.year || ''}
                        onChange={props.handleUnfiledReportInputChange}
                        fullWidth
                        margin="normal"
                    />
                    {props.isLitigationTab  && <FormControl fullWidth margin="dense">
                        <InputLabel id="report-status-label">Report Status</InputLabel>
                        <Select
                            labelId="report-status-label"
                            id="report-status-select"
                            name="reportStatusId"
                            value={props.currentUnfiledReport?.reportStatusId || ''}
                            onChange={handleSelectChange}
                            fullWidth
                            label="Report Status"
                            variant="outlined"
                        >
                            <MenuItem value="" disabled>
                                Select a report status
                            </MenuItem>
                            {reportStatusOptions.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleCloseUnfiledReportDialog}>Cancel</Button>
                    <Button onClick={props.handleSaveUnfiledReport} color="primary">Save</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default EditOrAddNewUnfiledReport;